/** @jsx jsx */
import { jsx } from "theme-ui";
import { useSelector } from "react-redux";
import { selectorSrcmProfile } from "../state/selectors";
import SignInButton from "./SignInButton";

export default function ensureSignedIn(Component) {
  return function EnhancedComponent(props) {
    const srcmProfile = useSelector(selectorSrcmProfile);
    if (srcmProfile) {
      return <Component {...props} />;
    }
    return (
      <SignInButton
        btnStyle={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "auto",
          height: "40px",
          background: "#0062cc",
          padding: "8px 18px",
          fontSize: "14px",
          border: "0!important",
          color: "#ffffff",
          borderRadius: "30px",
          "&: hover": {
            background: "#0056b3",
          },
        }}
        btnText="Sign-In to access this page"
      />
    );
  };
}
